
export { Ratio } from "/tmp/build_0d18d56a/packages/common/lib-esm/enums/common.js"